import { NavLink } from 'react-router-dom';
import css from './navbar.scss';

const Navbar = () => {
    return (
        <nav>
            <NavLink activeClassName={css.active} to="account">Мой профиль</NavLink>
            <NavLink activeClassName={css.active} to="feed">Лента</NavLink>
            <NavLink activeClassName={css.active} to="settings">Настройки</NavLink>
            <NavLink activeClassName={css.active} to="contacts">Контакты</NavLink>
            <NavLink activeClassName={css.active} to="calender">Календарь</NavLink>
            <NavLink activeClassName={css.active} to="myhealth">Здоровье</NavLink>
            <NavLink activeClassName={css.active} to="myposts">Публикации</NavLink>
            <NavLink activeClassName={css.active} to="aid">Фин. помощь</NavLink>
            <NavLink activeClassName={css.active} to="specialists">Специалисты</NavLink>
        </nav>
    );
}

export default Navbar;